import { type AnyAction } from "~/app/store/types";
import { contractsInitialState, type ContractsStore } from "~/features/contracts/redux/types";
import { POPUP_SET_INITIAL_VALUES, POPUP_UPDATE_DATE, POPUP_UPDATE_QTY } from "~/features/contracts/redux/actions";

export const contractsReducer = (state = contractsInitialState, action: AnyAction): ContractsStore => {
  switch (action.type) {
    case POPUP_UPDATE_QTY: {
      const newQty = action.payload as number;

      return {
        ...state,
        popupData: {
          ...state.popupData,
          selectedQty: newQty,
        },
      };
    }
    case POPUP_UPDATE_DATE: {
      const newDate = action.payload as Date;

      return {
        ...state,
        popupData: {
          ...state.popupData,
          selectedDate: newDate,
        },
      };
    }
    case POPUP_SET_INITIAL_VALUES: {
      const { qty, rdd } = action.payload as { qty: number; rdd: Date };

      return {
        ...state,
        popupData: {
          ...state.popupData,
          selectedDate: rdd,
          selectedQty: qty,
        },
      };
    }

    default:
      return state;
  }
};
